// extracted by mini-css-extract-plugin
export default {"container":"ProductViewer_container__gYCCJ","loading":"ProductViewer_loading__fYzc9","loaderGLB":"ProductViewer_loaderGLB__WMAQy","canvasStyle":"ProductViewer_canvasStyle__blDrN"};